import isNil from 'lodash/isNil';
import { v4 as uuid } from 'uuid';
import type { LocalDecorationId, RulesLogic } from './types.tsx';

export const generateLocalDecorationId = (): LocalDecorationId => uuid();

export const containsLogic = <T extends { logic?: RulesLogic | undefined | null }>(
	decoration: T,
): decoration is T & { logic: RulesLogic } => {
	return !isNil(decoration.logic);
};
